module.exports = __webpack_public_path__ + "static/media/iconMailSuccess.bd3d8714.svg";